import React from 'react';
import { Input, Button, Spin } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Category, Product, ProductOrderItem } from '../../../types/products';
import CategorySelector from '../CategorySelector';
import ProductGrid from '../ProductGrid';

interface ProductsPanelProps {
  categories: Category[];
  categoriesLoading: boolean;
  selectedCategoryId: string | null;
  onCategoryChange: (categoryId: string | null) => void;
  products: Product[];
  productsLoading: boolean;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  cartQuantities: Record<string, number>;
  onAddToOrder: (orderItem: ProductOrderItem) => void;
  hasActiveDailyMenu: boolean;
  onOpenDailyMenu: () => void;
  isMobile: boolean;
}

/**
 * Products panel with a single toolbar row: search + category pills +
 * Menú del Día. Shared by TakeOut and Delivery (was duplicated inline).
 */
const ProductsPanel: React.FC<ProductsPanelProps> = ({
  categories,
  categoriesLoading,
  selectedCategoryId,
  onCategoryChange,
  products,
  productsLoading,
  searchQuery,
  onSearchChange,
  cartQuantities,
  onAddToOrder,
  hasActiveDailyMenu,
  onOpenDailyMenu,
  isMobile,
}) => (
  <div className="ot-panel">
    <div className="ot-prodbar">
      <Input
        className="ot-prodbar__search"
        placeholder="Buscar…"
        prefix={<SearchOutlined />}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
      />
      <div className="ot-prodbar__cats">
        <CategorySelector
          categories={categories}
          selectedCategoryId={selectedCategoryId}
          onCategoryChange={onCategoryChange}
          loading={categoriesLoading}
          compact
          horizontalScroll
        />
      </div>
      {hasActiveDailyMenu && (
        <Button
          type="primary"
          onClick={onOpenDailyMenu}
          style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16', fontWeight: 'bold', flexShrink: 0 }}
        >
          Menú del Día
        </Button>
      )}
    </div>

    {productsLoading ? (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin size="large" />
      </div>
    ) : (
      <ProductGrid
        products={products}
        onAddToOrder={onAddToOrder}
        cartQuantities={cartQuantities}
        loading={productsLoading}
        compact={isMobile}
        reducedLayout
      />
    )}
  </div>
);

export default ProductsPanel;
